module.exports = __webpack_public_path__ + "files/874f3706a4bf86709d8a66cc2ae275f5.png";